import styled from 'styled-components';

const StyledContainer = styled.div`
	position: relative;
	width: 100%;
	display: flex;
	flex-direction: column;
	flex-grow: 1;
	row-gap: 26px;
`;

const StyledSliderContainer = styled.div`
	position: relative;
	height: 20px;
	display: flex;
	align-items: center;

	> div {
		width: 30px;
		height: 3px;
		border-top-left-radius: 4px;
		border-bottom-left-radius: 4px;
		background-color: #ffffff80;
	}

	&::before {
		content: '';
		position: absolute;
		left: 0;
		top: 50%;
		width: 100%;
		height: 5px;
		transform: translateY(-50%);
		background-color: #fff;
		opacity: 0.1;
		pointer-events: none;
	}
`;

const StyledSlider = styled.input.attrs({
	type: 'range',
})`
	appearance: none;
	width: 100%;
	margin: 0;
	background: transparent;
	cursor: pointer;
	border-radius: 10px;

	&:focus {
		outline: 0;
	}

	&::-webkit-slider-runnable-track {
		height: 5px;
	}

	&::-webkit-slider-thumb {
		appearance: none;
		margin-top: -3px;
		width: 11px;
		height: 11px;
		border-radius: 10px;
		background-color: #fff;
		background-clip: content-box;
	}

	&:disabled {
		pointer-events: none;
	}
`;

const StyledBottomCaption = styled.div`
	display: flex;
	justify-content: space-between;

	> span {
		font-family: 'GT Walsheim Pro';
		font-size: 12px;
		line-height: 14px;
		color: #fff;
		opacity: 0.25;
		user-select: none;
		pointer-events: none;
	}
`;

export {
	StyledContainer,
	StyledSliderContainer,
	StyledSlider,
	StyledBottomCaption,
};
